<template>
    <div>
        <div class="ui divider"></div>
        <div class="ui container contents">
            <!-- ERROR MESSAGES LIST -->
            <div class="ui red icon message" v-if="errors.length > 0">
                <i class="warning icon"></i>
                <div class="content">
                    <div class="header">
                        <!-- 請處理以下錯誤 -->
                        {{ $t('ui.notifications.error.please_handle_errors') }}
                    </div>
                    <p v-for="(error, index) in errors">{{index + 1}}. {{error}}</p>
                </div>
            </div>

            <div class="ui segment" v-if="is_initializing">
                <div class="ui active inverted dimmer">
                    <div class="ui text loader">
                        <!-- 讀取中 -->
                        {{ $t('ui.general.initializing') }}
                    </div>
                </div>
            </div>
            <div class="dashboard" v-else>
                <div class="ui top attached mini segment" :class="{'green': !is_processing && receiver_index != null, 'orange': !is_processing && receiver_index == null}">
                    <div class="ui top attached green progress" v-if="is_processing" :id="receiver + '-progress-bar'">
                        <div class="bar"></div>
                    </div>
                    <h3 class="ui header">
                        <i class="notched circle loading icon" v-if="is_processing"></i>
                        <i class="edit icon" v-else-if="!is_done"></i>
                        <i class="check icon" v-else></i>
                        <div class="content">
                            <span v-if="operation.identity">
                                <router-link
                                    v-if="current_scope == 'provider'"
                                    :to="{name: 'edit_provider_operation', params: {identity: operation.identity}}"
                                    target="_blank"
                                >
                                    {{ receiver }} {{ $t('models.operations') }} {{ operation.identity }}
                                </router-link>
                                <router-link
                                    v-if="current_scope == 'customer'"
                                    :to="{name: 'show_customer_operation', params: {identity: operation.identity}}"
                                    target="_blank"
                                >
                                    {{ receiver }} {{ $t('models.operations') }} {{ operation.identity }}
                                </router-link>
                            </span>
                            <span v-else>
                                {{ receiver }} {{ $t('models.operations') }} {{ operation.identity }}
                            </span>
                        </div>
                    </h3>
                </div>
                <div class="ui attached mini segment">
                    <table class="ui very basic table">
                        <tr>
                            <td class="center aligned">
                                <div class="ui gray label">
                                    <span>{{ requester_node.company_name }}</span>
                                </div>
                            </td>
                            <td class="center aligned"><i class="ui icon chevron right"></i></td>
                            <td class="center aligned">
                                <h4 class="operation_identity">
                                    <div v-popup class="ui orange label">
                                        {{ operator_node.company_name }}
                                    </div>
                                </h4>
                            </td>
                            <td class="center aligned"><i class="ui icon chevron right"></i></td>
                            <td class="center aligned">
                                <div class="ui gray label" :title="receiver_index">
                                    <span>
                                        <!-- 配送 -->
                                        {{ $t('ui.pages.uploader.delivery') }}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="ui attached segment form">
                    <div class="field" :class="{disabled: $parent.is_processing}">
                        <label>
                            <!-- 訂單備註 -->
                            {{ $t('models.operations') }}
                            {{ $t('ui.general.note') }}
                        </label>
                        <textarea v-if="!is_operation_created && !is_processing" rows="4" :placeholder="$t('models.operations')+' '+$t('ui.general.note')" v-model="operation.operator_note"></textarea>
                        <span v-else>{{operation.operator_note || '-'}}</span>
                    </div>
                </div>
                <div class="ui bottom attached segment">
                    <div class="ui accordion" :id="receiver_index + '-waybills-accordion'" v-accordion>
                        <div class="active title">
                            <i class="dropdown icon"></i>
                            {{ $t('ui.general.detail') }}
                        </div>
                        <div class="active content" style="overflow-x: scroll;">
                            <div is="Waybills" :operation_identity="operation.identity" :group="receiver"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Waybills from '../waybills/waybills.vue'
import Steps from './steps.vue'
export default {
    name: "UploaderOperation",
    props: {
        receiver: String,
        index: Number
    },
    data() {
        return {
            is_initializing: true,
            is_processing: false,
            is_operation_created: false,
            is_done: false,
            // Workflow Conrtol
            complete_count: 0,
            uploaded_count: 0,
            checked_count: 0,
            current_step: 1,
            // Datas
            receiver_index: null,
            operation: {
                receiver_node_identity: null,
                requester_node_identity: null,
                original_file_name: null,
                original_file_url: null,
                operator_note: "",
                identity: null
            },
            // Settings
            waybill_policy: {
                no_master: true,
                no_house: false,
                no_waybill: false,
                no_subwaybill: true
            },
            // Error Messages
            errors: [],
        }
    },
    computed: {
        current_scope() {
            return this.$store.state.current_scope
        },
        current_scoped_store() {
            return this.$store.state[this.current_scope]
        },
        requester_node() {
            return this.current_scoped_store.uploader_module.requester_node
        },
        requester_contract() {
            return this.current_scoped_store.uploader_module.requester_contract
        },
        is_customer_mode() {
            return this.$root.is_customer_mode
        },
        operator_node() {
            return this.current_scoped_store.uploader_module.operator_node
        },
        data_count() {
            return this.current_scoped_store.uploader_module.waybill_raw_datas[this.receiver].length
        },
        create_operation_url() {
            return this.current_scoped_store.uploader_module.create_operation_url
        },
        is_queue_mode() {
            return this.$parent.is_queue_mode
        }
    },
    mounted() {
        this.init()
        // 驗證計數器
        this.$bus.$off(this.receiver + 'add_checked_count')
        this.$bus.$on(this.receiver + 'add_checked_count', () => {
            // update counter
            this.checked_count++
            // step controller
            if (this.checked_count > 0) {
                if(this.checked_count == this.data_count) {
                    // this.$noty.success("運單內容檢查完成")
                    this.$noty.success(
                        this.$t('ui.pages.uploader.checking_waybill_data_ok')
                    )
                    this.steps_callback_center("validate_waybills")
                }
            }
        })

        // 上傳計數器
        this.$bus.$off(this.receiver + 'add_uploaded_count')
        this.$bus.$on(this.receiver + 'add_uploaded_count', () => {
            // update counter and new operation parameters
            this.uploaded_count++
            // step controller
            if (this.uploaded_count > 0) {
                if(this.uploaded_count == this.data_count) {
                    // this.$noty.success("訂單內容填寫完成")
                    this.$noty.success(
                        this.$t('ui.pages.uploader.checking_operation_data_ok')
                    )
                    this.steps_callback_center("create_waybills")
                }
            }
        })

        // 完成計數器＆進度條
        this.$bus.$off(this.receiver + 'add_complete_count')
        this.$bus.$on(this.receiver + 'add_complete_count', () => {
            // update counter
            this.complete_count++
            // completion controller
            if (this.data_count > 0) {
                if (this.complete_count == this.data_count) {
                    this.is_processing = false
                    this.$bus.$emit("to_index", "complete")
                    if (this.checked_count < this.complete_count) {
                        this.$bus.$emit("to_index", "interrupt")
                    }
                }
            }
            // update progress bar
            $('#' + this.receiver + '-progress-bar').progress({
                duration : 300,
                value    : this.complete_count,
                total    : this.data_count
            })
        })

        // Components報錯回報中心
        this.$bus.$off(this.receiver + 'add_errors')
        this.$bus.$on(this.receiver + 'add_errors', error => {
            this.errors.push(error)
        })

        // Index溝通頻道
        this.$bus.$off("to_operations")
        this.$bus.$on("to_operations", (mission, operation_index) => {
            switch (mission) {
                case "validate_waybills":
                    if (this.index == operation_index) {
                        this.validate_waybills()
                    }
                    break
                case "create_operation":
                    if (this.index == operation_index) {
                        this.create_operation()
                    }
                    break
                default:

            }
        })
    },
    methods: {
        init() {
            const promise = new Promise((resolve, reject) => {
                resolve()
                this.is_initializing = false
            })
        },
        // Step Actions
        validate_waybills() {
            this.errors = []
            this.complete_count = 0
            this.checked_count = 0
            this.is_processing = true
            this.$bus.$emit(this.receiver + 'broadcast_validate_waybills')
        },
        create_operation() {
            this.is_processing = true
            this.errors = []
            if (this.operation.identity == null) {
                if (this.current_scope == "provider") {
                    var data = {
                        contract_identity: this.requester_contract.identity,
                        customer_identity: this.requester_node.identity,
                        provider_note: this.operation.operator_note,
                        original_file_name: this.$parent.file_name,
                        original_file_url: this.$parent.file_s3_path,
                        converter_identity: this.current_scoped_store.uploader_module.current_converter.identity,
                    }
                    var auth_token = localStorage.getItem("authentication_token")
                } else if (this.current_scope == "customer") {
                    var data = {
                        contract_identity: this.requester_contract.identity,
                        customer_identity: this.requester_node.identity,
                        customer_note: this.operation.operator_note,
                        original_file_name: this.$parent.file_name,
                        original_file_url: this.$parent.file_s3_path,
                        converter_identity: this.current_scoped_store.uploader_module.current_converter.identity,
                    }
                    var auth_token = localStorage.getItem("customer_authentication_token")
                }
                axios.post(this.create_operation_url, data, {headers: { Authorization: auth_token }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.operation = response.data.operation
                            this.is_operation_created = true
                            // this.$noty.success("實體化訂單")
                            this.$noty.success(
                                this.$t('ui.pages.uploader.materialization_operation')
                            )
                            setTimeout(() => {
                                this.steps_callback_center("create_operation")
                            }, 1000)
                        } else {
                            _.forEach(response.data.errors, (messages) => {
                                _.forEach(messages, message => {
                                    this.errors.push(message)
                                })
                            })
                            this.steps_callback_center("interrupt")
                        }
                    })
                    .catch(error => {
                        // this.errors.push("無法實體化新訂單: " + error.response.status + " " + error.response.data)
                        if (typeof(error.response.data) == 'object') {
                            Object.keys(error.response.data.detail).forEach(key => {
                                this.errors.push(
                                    this.$t('ui.pages.uploader.materialization_operation') + " " +
                                    this.$t('ui.general.error') + ": " +
                                    this.$t('models.attributes.operations.' + key) + error.response.data.detail[key][0]
                                )
                            });
                        } else {
                            this.errors.push(
                                this.$t('ui.pages.uploader.materialization_operation') + " " +
                                this.$t('ui.general.error') + ": " +
                                error.response.status + " " + error.response.data
                            )
                        }
                        this.steps_callback_center("interrupt")
                    })
            } else {
                this.steps_callback_center("create_operation")
            }
        },
        create_waybills() {
            this.complete_count = 0
            this.$bus.$emit(this.receiver + 'broadcast_create_waybills')
        },
        // 流程控制
        steps_callback_center(function_name) {
            console.log("Operation" + this.index + "步驟控制中心收到完成步驟：" + function_name)
            switch (function_name) {
                case "validate_waybills":
                    this.$bus.$emit("to_index", "validate_waybills", this.index)
                    this.is_processing = false
                    this.current_step++
                    break
                case "create_operation":
                    if (this.is_queue_mode) {
                        // 略過create waybills
                        this.steps_callback_center("create_waybills")
                    } else {
                        this.create_waybills()
                    }
                    break
                case "create_waybills":
                    this.$bus.$emit("to_index", "create_operation", this.index)
                    $('#' + this.receiver_index + '-waybills-accordion').accordion("close", 0)
                    this.is_processing = false
                    this.is_done = true
                    this.current_step++
                    break
                case "interrupt":
                    this.is_processing = false
                    this.$parent.is_processing = false
                    break
                default:

            }
        }
    },
    components: {
        Waybills,
        Steps,
    }
}
</script>
